import { useState } from "react";
import type { EvalHidProject } from "../model/types.ts";

/**
 * Which sub-basin/outlet point/aquifer is currently open in its own edit
 * dialog — shared shape between SubBasinMap.tsx and SubBasinCanvas.tsx
 * (map and card views of the same entities), which both need the RAW codes
 * too (not just the resolved objects below): the map uses them for
 * highlighting the edited feature and building its GeoJSON remount
 * `signature`, the card view for its own selection bookkeeping. Only the
 * dialog JSX itself is shared (see EntityEditDialogs.tsx) — the codes stay
 * owned by whichever view is currently mounted.
 */
export function useEntityEditDialogs(project: EvalHidProject) {
  const [editingSubBasin, setEditingSubBasin] = useState<number | null>(null);
  const [editingOutlet, setEditingOutlet] = useState<number | null>(null);
  const [editingAquifer, setEditingAquifer] = useState<number | null>(null);

  const editingSubBasinObj = project.subBasins.find((c) => c.subBasinCode === editingSubBasin);
  const editingOutletObj = project.outletPoints.find((p) => p.outletCode === editingOutlet);
  const editingAquiferObj = project.aquifers.find((a) => a.aquiferCode === editingAquifer);

  return {
    editingSubBasin,
    setEditingSubBasin,
    editingSubBasinObj,
    editingOutlet,
    setEditingOutlet,
    editingOutletObj,
    editingAquifer,
    setEditingAquifer,
    editingAquiferObj,
  };
}
